<template>
  <div>
        <h2>Heart</h2>

    <v-container v-if="!loading" class="py-10">
        <v-row>
            <v-col v-for="item in heart" class="shrink my-0 py-0" cols="12" md="4" :key="item.id">
                <v-checkbox
                        v-model="heartCheckbox"
                        :disabled="disableHeart(item.id, item.is_normal)"
                        :label='item.name'
                        :value="item.id"
                        hide-details
                        @change="toggle => heartTick(item.id, toggle, item.is_normal)"
                />
            </v-col>
        </v-row>
        <v-row v-if="isHeartRemark">
            <v-col>
                <v-text-field
                        placeholder="Other"
                        outlined
                        v-model="heart_remark"
                        :rules="[v => !!v || 'Heart Other is required']"
                        label="Heart Other"
                        @keyup="includeHeartRemark"
                        required
                />
            </v-col>
        </v-row>
    </v-container>
    <v-container v-else style="text-align: center;">
      <v-progress-circular
        :size="150"
        color="primary"
        indeterminate
        style="text-align: center"
      >Loading Data
      </v-progress-circular>
    </v-container>
  </div>
</template>

<script>
    export default {
        name: "Heart",

        props: {
            formData: {
                type: Object,
                required: true,
            },
            config: Number
        },

        data() {
            return {
                isHeartRemark: false,
                heart_remark: null,
                isHeartNormal: false,
                heart: {},
                heartCheckbox: [],
                loading: true,
            }
        },

        methods: {
            editFieldHeart() {
                let vm = this;
                _.forEach(this.formData.physical_examination.heart, function(value) {
                    vm.heartCheckbox.push(Number.parseInt(value.heart_id));
                    if (value.heart_remark) {
                        vm.heart_remark = value.heart_remark;
                        vm.isHeartRemark = true;
                    }
                });
            },

            disableHeart(id, normal = 0, toggle = true) {
                let vm = this;
                _.forEach(this.formData.physical_examination.heart, function (value) {
                    if (Number.parseInt(value.heart_id) === Number.parseInt(id) && normal && toggle) {
                        vm.isHeartNormal = true;
                    }
                });
                return this.heartCheckbox.indexOf(id) === -1 && this.isHeartNormal;
            },

            heartTick(key, toggle, is_normal) {
                let toggled = toggle.includes(Number.parseInt(key));
                let heart = this.formData.physical_examination.heart;

                if (key === this.config) {
                    this.isHeartRemark = !this.isHeartRemark;
                }
                if (is_normal) {
                    this.isHeartNormal = !this.isHeartNormal;
                    this.heartNormalOnly(key, toggled);
                    this.disableHeart(key, is_normal, toggled);
                }

                if (toggled) {
                    heart.push({
                        heart_id: key,
                        heart_remark: null,
                    });
                } else {
                    let index = heart.findIndex(heart => heart.heart_id === key);
                    heart.splice(index, 1);
                }
            },

            heartNormalOnly(key, toggled) {
                if (toggled){
                    let heart = this.formData.physical_examination.heart;
                    heart.push({
                        heart_id: key,
                        heart_remark: null,
                    });
                    this.heartCheckbox = [key];
                    heart.splice(0, heart.length);
                    this.isHeartRemark = false;
                }
            },

            includeHeartRemark() {
                let heart = this.formData.physical_examination.heart;
                let index = heart.findIndex(heart => heart.heart_id === this.config);
                heart.splice(index, 1);
                heart.push({
                    heart_id: this.config,
                    heart_remark: this.heart_remark,
                });
            },

            getHeartLib() {
                this.axios.get('heart-lib', {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
                    }
                }).then((response) => {
                    // handle success
                    this.heart = response.data;
                    this.loading = false;
                }).catch((error) => {
                    // handle error
                    console.error(error);
                }).finally(() => {
                    // always executed
                });
            },
        },

        mounted() {
            this.getHeartLib();
            this.editFieldHeart();
        }
    }
</script>

<style scoped>

</style>